import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { getFaqPageData } from '../../../services/cmsPage.service';
import { Accordion } from 'react-bootstrap';
import "./style.scss";

const Faq = () => {

  const [faqData, setFaqData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getFaqPageData();

        setFaqData(Array.isArray(response) ? response : []);
        setLoading(false);
      }
      catch (error: any) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };
    fetchData();
  }, []);


  return (
    <div className="faqPage">
      <section className="banner-section">
        <div className="container">
          <div className="row ">
            <div className="col-md-12 ">
              <div className="main-heading d-flex justify-content-center align-items-center">
                <h1 className="hero-title capitalize">FAQ</h1>
              </div>
            </div>
          </div>
        </div>
      </section>


      <div className="faqContent">
        <div className="container">
          <h2 className="text-center">
            Frequently Asked Questions About Trac - Nest
          </h2>

          {loading ? (
            <section className="py-5 bg-light">
              <div className="container">
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "50vh" }}>
                  <div
                    className="spinner-border text-primary"
                    role="status"
                    style={{ width: "3rem", height: "3rem" }}
                  >
                    <span className="visually-hidden">Loading…</span>
                  </div>
                </div>
              </div>
            </section>
          ) : (
            <>
              {faqData.length > 0 && (
                <Accordion defaultActiveKey="0">
                  {faqData.map((item: any, index: number) => (
                    <Accordion.Item key={index} eventKey={index.toString()}>
                      <Accordion.Header>
                        {item.question.replace(/<[^>]*>/g, '')}
                      </Accordion.Header>
                      <Accordion.Body
                        dangerouslySetInnerHTML={{ __html: item.answer }}
                      />
                    </Accordion.Item>
                  ))}
                </Accordion>
              )}
            </>
          )}

        </div>
      </div>
    </div>

  )
}

export default Faq